<div class="rt-split">
  <app-auth-brand-panel></app-auth-brand-panel>
  <div class="rt-login-col">
    <div class="rt-login-form" *ngIf="!resetPassword">
      <h2 class="rt-title">{{ 'app.login.welcome_back' | translate }}</h2>
      <form #loginForm="ngForm" (ngSubmit)="onSubmit(loginForm)">
        <div class="rt-field rt-field-identity">
          <input class="rt-input" type="text" [value]="email" readonly tabindex="-1" />
          <a class="rt-link rt-change-email" [title]="'app.login.change' | translate" (click)="goBack()">{{ 'app.login.change' | translate }}</a>
        </div>

        <div class="rt-field rt-field-password">
          <ejs-textbox class="rt-input" [(ngModel)]="password" name="loginpassword" [placeholder]="'app.login.password' | translate"
            [type]="showPassword ? 'text' : 'password'" required #passwordRef="ngModel" (ngModelChange)="onPasswordChange($event)"></ejs-textbox>
          <img class="rt-toggle" [class.rt-toggle-on]="showPassword" src="assets/vectors/password-visibility.svg"
            [alt]="(showPassword ? 'app.login.hide_password' : 'app.login.show_password') | translate"
            [title]="(showPassword ? 'app.login.hide_password' : 'app.login.show_password') | translate"
            (click)="togglePasswordVisibility()" />
        </div>

        <div *ngIf="passwordFormatError" class="rt-validation">{{ passwordFormatError }}</div>
        <div *ngIf="!passwordFormatError && isSubmitted && passwordRef.invalid" class="rt-validation">
          {{ 'app.login.password_is_required' | translate }}
        </div>
        <div *ngIf="!passwordFormatError && errorMessage && errorMessage !== 'Email is verified.' && !passwordRef.invalid" class="rt-validation">
          {{ errorMessage }}
        </div>

        <div class="rt-links rt-remember-row">
          <div class="rt-remember">
            <ejs-checkbox></ejs-checkbox>
            <label class="rt-remember-label">{{ 'app.login.remember_me' | translate }}</label>
          </div>
          <a class="rt-link" (click)="showResetPassword()">{{ 'app.login.forgot_password' | translate }}</a>
        </div>

        <button ejs-button type="submit" class="rt-btn-primary" [disabled]="loginPending">{{ 'app.login.sign_in' | translate }}</button>
      </form>
    </div>
  </div>
</div>
